import React, {Suspense} from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import {auth} from './helpers/firebase';
import {UserProvider} from './contexts/userContext';
import {UserRoleProvider} from './contexts/userRoleContext';
import {AppProvider} from '@shopify/polaris';
import translations from '@shopify/polaris/locales/en.json';
import Loading from './components/Loading/Loading';

const RequiredLogin = React.lazy(() => import('./components/RequiredLogin/RequiredLogin'));

window.isAuthenticated = false;

auth.onAuthStateChanged(async user => {
  if (user === null && !window.isAuthenticated) {
    return ReactDOM.render(
      <Suspense fallback={<Loading />}>
        <AppProvider i18n={translations}>
          <React.StrictMode>
            <RequiredLogin />
          </React.StrictMode>
        </AppProvider>
      </Suspense>,
      document.getElementById('root')
    );
  }

  return ReactDOM.render(
    <AppProvider i18n={translations}>
      <React.StrictMode>
        <UserProvider value={{user}}>
          <UserRoleProvider>
            <App />
          </UserRoleProvider>
        </UserProvider>
      </React.StrictMode>
    </AppProvider>,
    document.getElementById('root')
  );
});
